document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    // Only run when buttons exist
    const buttons = document.querySelectorAll("input.sr-only");
    if (buttons.length > 0) {
      buttons.forEach((btn) => {
        if (!btn.dataset.listenerAdded) {
          btn.addEventListener("change", () => {
            safeUpdatePerDay();
          });
          btn.dataset.listenerAdded = "true";
        }
      });

      // Initial run
      safeUpdatePerDay();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  function safeUpdatePerDay() {
    const activeOption = document.querySelector(
      ".appstle_subscription_wrapper_option.appstle-active-option"
    );
    if (!activeOption) return;

    const priceElement = activeOption.querySelector(
      ".appstle_subscription_amount"
    );
    if (!priceElement) return;

    const text = priceElement.textContent.trim();
    const num = parseFloat(text.replace("£", ""));
    if (isNaN(num)) return;

    const perDay = (num / 30).toFixed(2);
    console.log(`Active option per day: £${perDay}`);

    // Disconnect observer temporarily to prevent infinite loops
    observer.disconnect();

    // Check if per-day element exists
    let perDayDiv = activeOption.querySelector(".per-day-display");
    if (!perDayDiv) {
      perDayDiv = document.createElement("div");
      perDayDiv.className = "per-day-display";
      perDayDiv.style.fontSize = "0.9em";
      perDayDiv.style.color = "#555";
      perDayDiv.style.marginTop = "4px";
      activeOption.appendChild(perDayDiv);
    }

    // Update content safely
    perDayDiv.textContent = `£${perDay}/day`;

    // Reconnect observer
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  wdsSetUpsellData();
  document.addEventListener("change", function (e) {
    const select = e.target.closest(".lb-variant-picker");
    if (!select) return;
    const card = select.closest(".lb-product-card");
    const subQty = Number(card.getAttribute("data-subscription-qty"));
    setTimeout(function () {
      wdsSetUpsellProductData(card, subQty);
    }, 100);
  });
  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest(".lb-button");
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      const cardProduct = btn.closest(".lb-product-card");
      const items = [
        {
          id: cardProduct.getAttribute("lb-variant-id"),
          quantity: 1,
          selling_plan: cardProduct.getAttribute("data-selling-plan"),
        },
      ];
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((res) => res.json())
        .then((data) => {
          wdsSetUpsellData();
          if (document.querySelector(".shopify-section--main-cart")) {
            window.location.href = "/cart";
          } else {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        })
        .catch((err) => console.error("Error:", err));
    },
    true
  );
  document.addEventListener("cart:change", function (e) {
    wdsAddedGift();
  });
  document.addEventListener("cart:refresh", function () {
  wdsAddedGift();
});

document.addEventListener("DOMContentLoaded", function () {
  wdsAddedGift();
});
});

async function wdsGetCart() {
  const result = await fetch("/cart.js");
  return await result.json();
}
async function wdsSetUpsellData() {
  const cart = await wdsGetCart();
  let subQty = 0;
  cart.items.forEach((item) => {
    if (item.selling_plan_allocation) {
      subQty++;
    }
  });
  if (subQty > 1) {
    subQty = 2;
  }
  const observer = new MutationObserver(() => {
    const upsellProducts = document.querySelectorAll(".lb-product-card");
    if (upsellProducts.length > 0) {
      upsellProducts.forEach((item) => {
        item.setAttribute("data-subscription-qty", subQty);
        wdsSetUpsellProductData(item, subQty);
      });
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
async function wdsAddedGift() {
  const cart = await wdsGetCart();
  let notGift = true;
  let subscripiton = false;
  let giftKey = "";
  if (cart.item_count === 0) return;
  cart.items.forEach((item) => {
    if (item.id === 52008776237397) {
      giftKey = item.key;
      notGift = false;
    }
    if (item.id !== 52008776204629 && item.selling_plan_allocation) {
      subscripiton = true;
    }
  });
  if (notGift && subscripiton) {
    const items = [
      {
        id: 52008776237397,
        quantity: 1,
      },
    ];
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((err) => console.error("Error:", err));
  } else if (!notGift && !subscripiton) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: giftKey,
        quantity: 0,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((err) => console.error("Error:", err));
  }
}
function wdsSetUpsellProductData(cardProduct, subQty) {
  const variantId = cardProduct.getAttribute("lb-variant-id");
  fetch(`/variants/${variantId}.js`)
    .then((r) => r.json())
    .then((variant) => {
      if (variant.selling_plan_allocations) {
        const oldLabel = cardProduct.querySelector(".lb-sale-badge");
        if (oldLabel) {
          oldLabel.remove();
        }
        const price = "£" + (variant.selling_plan_allocations[subQty].price / 3000).toFixed(2) + '/day';
        const sale = ((variant.selling_plan_allocations[subQty].compare_at_price - variant.selling_plan_allocations[subQty].price) / 100).toFixed(2);
        const saleLabel = document.createElement("div");
        saleLabel.className = "lb-sale-badge";
        saleLabel.textContent = "Save £" + sale;
        cardProduct.setAttribute("data-selling-plan", variant.selling_plan_allocations[subQty].selling_plan_id);
        cardProduct.querySelector(".lb-price-sale-price").textContent = price;
        cardProduct.appendChild(saleLabel.cloneNode(true));
      }
    });
}
/* =========================================================
   HOUND: Tiered Recharge selling_plan switcher (cart-order based)
   Rule:
   - 1st subscription item = tier 1 (1 Product)
   - 2nd subscription item = tier 2 (2 Product)
   - 3rd+ subscription items = tier 3 (3 Product)
   ========================================================= */

(function () {
  const GIFT_VARIANT_ID = 52008776237397; // Dental Chews Gift variant (exclude)
  const DEBUG = false;

  // Recharge selling_plan IDs (External Plan ID) by product_id -> size -> tier
  const PLAN_MAP = {
    // Calming & Anxiety (product_id 10162699469141)
    10162699469141: {
      small:  { 1: 690888769877, 2: 690903482709, 3: 690903646549 },
      medium: { 1: 690903449941, 2: 690903581013, 3: 690903679317 },
      large:  { 1: 690903548245, 2: 690903515477, 3: 690903613781 }
    },

    // Daily Multivitamin (product_id 10162697503061)
    10162697503061: {
      small:  { 1: 690888835413, 2: 690903253333, 3: 690903220565 },
      medium: { 1: 690903318869, 2: 690903417173, 3: 690903384405 },
      large:  { 1: 690903286101, 2: 690903351637, 3: 690903187797 }
    },

    // Digestive Support (product_id 10162694881621)
    10162694881621: {
      small:  { 1: 690902991189, 2: 690902925653, 3: 690903122261 },
      medium: { 1: 690902892885, 2: 690902958421, 3: 690903089493 },
      large:  { 1: 690903056725, 2: 690903023957, 3: 690903155029 }
    },

    // Hip & Joint (product_id 10162712707413)
    10162712707413: {
      small:  { 1: 690888900949, 2: 690902335829, 3: 690902466901 },
      medium: { 1: 690902270293, 2: 690902368597, 3: 690902532437 },
      large:  { 1: 690902303061, 2: 690902401365, 3: 690902499669 }
    },

    // Skin & Coat (product_id 10162711560533)
    10162711560533: {
      small:  { 1: 690888868181, 2: 690902696277, 3: 690902663509 },
      medium: { 1: 690902729045, 2: 690902630741, 3: 690902794581 },
      large:  { 1: 690902827349, 2: 690902597973, 3: 690902761813 }
    }
  };

  let busy = false;
  let queued = false;
  let timer = null;

  function log(...args) { if (DEBUG) console.log("[PLAN-SWITCH]", ...args); }

  function normalizeSizeFromItem(item) {
    // Best source: options_with_values Size
    if (Array.isArray(item.options_with_values)) {
      const sizeOpt = item.options_with_values.find(o => (o.name || "").toLowerCase() === "size");
      if (sizeOpt && sizeOpt.value) {
        const v = sizeOpt.value.toLowerCase();
        if (v.includes("small")) return "small";
        if (v.includes("medium")) return "medium";
        if (v.includes("large")) return "large";
      }
    }
    // Fallback: variant_title
    const vt = (item.variant_title || "").toLowerCase();
    if (vt.includes("small")) return "small";
    if (vt.includes("medium")) return "medium";
    if (vt.includes("large")) return "large";
    return null;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" }});
    return await res.json();
  }

  async function changeSellingPlan(lineKey, sellingPlanId) {
    // Shopify accepts selling_plan on change.js for subscription line edits
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: lineKey, selling_plan: sellingPlanId })
    });
    return await res.json();
  }

  async function applyTierPlans() {
    if (busy) { queued = true; return; }
    busy = true;

    try {
      const cart = await getCart();
      if (!cart || !Array.isArray(cart.items)) return;

      // Subscription items only (exclude gift)
      const subs = cart.items.filter(it =>
        it.selling_plan_allocation &&
        it.variant_id !== GIFT_VARIANT_ID
      );

      if (subs.length === 0) return;

      // Determine desired tier per cart order
      const updates = [];
      subs.forEach((item, idx) => {
        const tier = idx === 0 ? 1 : (idx === 1 ? 2 : 3);
        const productId = item.product_id;
        const size = normalizeSizeFromItem(item);

        if (!PLAN_MAP[productId] || !size || !PLAN_MAP[productId][size]) {
          log("Missing mapping for", { productId, size, tier, title: item.title });
          return;
        }

        const desiredPlanId = PLAN_MAP[productId][size][tier];
        const currentPlanId = item.selling_plan_allocation?.selling_plan?.id;

        // If already correct, do nothing
        if (Number(currentPlanId) === Number(desiredPlanId)) return;

        updates.push({
          key: item.key,
          title: item.title,
          tier,
          size,
          from: currentPlanId,
          to: desiredPlanId
        });
      });

      if (updates.length === 0) return;

      log("Applying plan switches:", updates);

      // Apply sequentially (avoids race conditions)
      for (const u of updates) {
        await changeSellingPlan(u.key, u.to);
      }

      // Refresh UI
      document.dispatchEvent(new CustomEvent("cart:refresh"));

    } catch (e) {
      console.error("Tier plan switch error:", e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        // run again in case cart changed mid-flight
        setTimeout(applyTierPlans, 150);
      }
    }
  }

  function scheduleApply() {
    clearTimeout(timer);
    timer = setTimeout(applyTierPlans, 200);
  }

  // Run on load + common cart events
  document.addEventListener("DOMContentLoaded", scheduleApply);
  document.addEventListener("cart:refresh", scheduleApply);
  document.addEventListener("cart:change", scheduleApply);

  // Fallback: watch quantity buttons/inputs in cart drawer & cart page
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("button, a");
    if (!btn) return;
    const txt = (btn.textContent || "").toLowerCase();
    if (txt.includes("remove") || txt.includes("+") || txt.includes("−") || txt.includes("-")) {
      scheduleApply();
    }
  }, true);

  document.addEventListener("change", (e) => {
    if (e.target && (e.target.name === "updates[]" || e.target.matches("input[type='number']"))) {
      scheduleApply();
    }
  }, true);

})();

